export const isNil = <T>(value: T | null | undefined): value is null | undefined =>
  value === null || value === undefined;
export const notNil = <T>(value: T | null | undefined): value is T => !isNil(value);
export const isFalsy = <T>(value: T | undefined): boolean => value === undefined || value === false;
export const falsy = <T>(value: T, otherValue?: T): undefined | false => {
  if (typeof value === 'boolean' || typeof otherValue === 'boolean') {
    return false;
  }
  return undefined;
};
